import PropTypes from 'prop-types';
import { Map as ImmutableMap } from 'immutable';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import { AnyCrmObjectTypePropType } from 'customer-data-objects-ui-components/propTypes/CrmObjectTypes';
import logTimelineMountTiming from '../../../utils/logTimelineMountTiming';
import TimelineCard from '../generic/TimelineCard';
import { useEffect } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const TimelineEvent = ({
  ChildComponent,
  dataStartTime,
  objectType,
  profileStartTime,
  subjectId,
  timelineItem
}) => {
  useEffect(() => {
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 0 arguments, but got 2.
    logTimelineMountTiming(dataStartTime, profileStartTime);
  }, [profileStartTime, dataStartTime]);
  if (!timelineItem) {
    return null;
  }
  return /*#__PURE__*/_jsx(TimelineCard, {
    objectType: objectType,
    subjectId: subjectId,
    timelineItem: timelineItem,
    TimelineEventComponent: ChildComponent
  });
};
TimelineEvent.propTypes = {
  ChildComponent: PropTypes.elementType,
  dataStartTime: PropTypes.number,
  objectType: AnyCrmObjectTypePropType.isRequired,
  profileStartTime: PropTypes.number,
  subjectId: PropTypes.string.isRequired,
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof Map' is not assignable to... Remove this comment to see the full error message
  timelineItem: PropTypes.instanceOf(ImmutableMap).isRequired
};
export default TimelineEvent;